import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeEntity, changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    FAQS_REQUEST: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
    FAQS_RECEIVE_LIST: receiveList,
    FAQS_CHANGE_FILTER: changeFilter,
    CHANGE_ENTITY_FAQS: changeEntity,
    INVALIDATE_FAQS: invalidateFilters,
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    entities: {},
    result: {},
    counts: {},
    filters: {},
}

export default createReducer(initialState, handlers)
